import React, { useEffect } from 'react';
import { useTask } from '../contexts/TaskContext';
import TaskDashboard from '../components/TaskDashboard';

const DashboardPage = () => {
    const { setActiveView } = useTask();

    useEffect(() => {
        setActiveView('dashboard');
    }, [setActiveView]);

    return <TaskDashboard />;
};

export default DashboardPage;
